/**
 * HomeSpace Icon — "Zuhause" Life Space
 *
 * House with heart icon from Figma design.
 * Compatible with Lucide icon API (size + color props).
 *
 * @example
 * <HomeSpaceIcon size={16} />
 */
export const HomeSpaceIcon = ({ size = 16, color }: { size?: number; color?: string }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 17 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.66 7.67L8.17 0.67L0.67 7.67"
        stroke={color || 'currentColor'}
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.67 8.67V15.66H13.66V8.67"
        stroke={color || 'currentColor'}
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.11 7.7C10.9 7.5 10.66 7.36 10.39 7.27C10.12 7.18 9.84 7.15 9.56 7.18C9.28 7.21 9.01 7.3 8.77 7.44C8.53 7.59 8.32 7.78 8.16 8.01C8.01 7.78 7.8 7.59 7.56 7.44C7.32 7.3 7.05 7.21 6.77 7.18C6.49 7.15 6.2 7.18 5.94 7.27C5.67 7.36 5.43 7.5 5.22 7.7C5.05 7.86 4.91 8.07 4.81 8.29C4.71 8.52 4.67 8.76 4.67 9C4.67 9.25 4.71 9.49 4.81 9.72C4.91 9.94 5.05 10.14 5.22 10.31L8.16 13.17L11.11 10.31C11.28 10.14 11.42 9.94 11.52 9.72C11.61 9.49 11.66 9.25 11.66 9C11.66 8.76 11.61 8.52 11.52 8.29C11.42 8.07 11.28 7.86 11.11 7.7Z"
        stroke={color || 'currentColor'}
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
